const useCurrencyDisplay = () => {
    const translateCurrency = (val) => {
        return val?.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    return { translateCurrency };
};

export default useCurrencyDisplay;
